import * as Sentry from '@sentry/react';

if (import.meta.env.VITE_CI === 'true') {
  Sentry.init({
    dsn: 'https://2d0f985bf86fa9beeef90130b4a2c763@o4511060570472448.ingest.de.sentry.io/4511060579123280',
    // Adds request headers and IP for users, for more info visit:
    // https://docs.sentry.io/platforms/javascript/guides/react/configuration/options/#sendDefaultPii
    sendDefaultPii: true,
    integrations: [],
    environment: import.meta.env.MODE,
  });
}
